import React from "react";

export type Props = {
  label?: string;
  value: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isLoading?: boolean;
  rows?: number;
  isRequired?: boolean;
  hasError?: boolean;
  placeholder?: string;
};
const Textarea: React.FC<Props> = ({
  label = "",
  value,
  disabled = false,
  onChange,
  isLoading = false,
  rows = 4,
  isRequired = false,
  hasError = false,
  placeholder = "",
}) => {
  return (
    <div className="field">
      <label className="label is-small">
        {label}
        {isRequired && <span className="has-text-danger">*</span>}
      </label>
      <div className={`control${isLoading && " is-loading"}`}>
        <textarea
          rows={rows}
          className={`${
            (isRequired && !value) || hasError ? "is-danger " : ""
          }textarea is-small is-fullwidth is-radiusless`}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default Textarea;
